import { ReactNode, useEffect } from 'react';

import { FormProvider, useForm } from 'react-hook-form';

import { EMPTY_FORM, TMobileSignupForm } from './form';
import { applicationToForm, stateToForm } from './mapping';
import {
  useGetApplicationQuery,
  useGetSelectStateQuery,
} from '../../../api/lendingApi/lendingApiQueries';
import { TGetStateResponseDE } from '../../../lapiOverrideTypesDE';

export const MobileSignupFormProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { application } = useGetApplicationQuery();
  const { normalisedState } = useGetSelectStateQuery((data) =>
    stateToForm((data as TGetStateResponseDE).data),
  );

  const methods = useForm<TMobileSignupForm>({
    // Keep fields registered across screen unmounts so values persist for the whole flow.
    shouldUnregister: false,
    defaultValues: EMPTY_FORM,
  });

  // defaultValues are captured at mount, so the async GET needs an explicit reset once
  // it resolves. keepDirtyValues preserves edits the user has already made.
  useEffect(() => {
    if (!normalisedState) return;
    methods.reset(
      { ...EMPTY_FORM, ...normalisedState, ...applicationToForm(application) },
      { keepDirtyValues: true },
    );
  }, [normalisedState, application, methods]);

  return <FormProvider {...methods}>{children}</FormProvider>;
};
